import { toDp } from "./Math";
import { CurrencySymbolDictionary } from "../Enums/Dictionaries/CurrencySymbolDictionary";
import { Money } from "../../Wrap/Core/DataTypes/Money";

export function formatMoney(
    money: Money,
    noCurrencyCode?: boolean,
    rounding = 2,
    showPlusSign = false,
    showMinusSign = true
): string {
    const currencySymbol = CurrencySymbolDictionary.getSymbol(money.Currency);

    const oldCurrencySymbol = Globalize.culture().numberFormat.currency.symbol;
    const oldPattern = Globalize.culture().numberFormat.currency.pattern;

    // TODO the Globalize library should be set to proper language etc. ONCE during initialization and after each language change
    Globalize.culture().numberFormat.currency.symbol = currencySymbol;

    const plusSignNoCurrency = ["n", "n"];
    const plusSignCurrency = ["$n", "$n"];

    if (noCurrencyCode) {
        Globalize.culture().numberFormat.currency.pattern = plusSignNoCurrency;
    } else {
        Globalize.culture().numberFormat.currency.pattern = plusSignCurrency;
    }

    const roundedValue = toDp(money.Amount, rounding);
    let formattedValue = Globalize.format(roundedValue || 0, "C" + rounding);

    // not solved via pattern as the + sign was showing up even when the value was 0
    formattedValue = (showPlusSign && roundedValue > 0 ? "+" : "") + (!noCurrencyCode ? " " : "") + formattedValue;
    formattedValue = (showMinusSign && roundedValue < 0 ? "−" : "") + (!noCurrencyCode ? " " : "") + formattedValue;

    Globalize.culture().numberFormat.currency.symbol = oldCurrencySymbol;
    Globalize.culture().numberFormat.currency.pattern = oldPattern;

    return formattedValue;
}
